// ============================================
// VOLUNTEER DATA CONTEXT
// Single source of truth for volunteer data freshness.
//
// Any time a volunteer is created, edited, deleted or
// imported from anywhere in the app, call bump().
// Every page that lists volunteers watches `version`
// and refreshes automatically.
//
// This prevents stale lists, race conditions, and the
// "I deleted it but it's still here" class of bug.
// ============================================

import React, { createContext, useContext, useState, useCallback } from "react";

const VolunteerDataContext = createContext({
  version: 0,
  bump: () => {},
});

export function VolunteerDataProvider({ children }) {
  const [version, setVersion] = useState(0);
  const bump = useCallback(() => setVersion(v => v + 1), []);
  return (
    <VolunteerDataContext.Provider value={{ version, bump }}>
      {children}
    </VolunteerDataContext.Provider>
  );
}

export function useVolunteerData() {
  return useContext(VolunteerDataContext);
}